var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup d-flex justify-content-center align-items-center",
      class: { "popup--visible": _vm.is_open },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row d-flex justify-content-center" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-10 col-lg-8 popup__container popup__container--start",
            },
            [
              _c(
                "a",
                {
                  staticClass: "popup__close",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.closePopup.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "popup__close__ico",
                      attrs: {
                        width: "16px",
                        height: "16px",
                        viewBox: "0 0 16 16",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "desktop_design",
                            stroke: "none",
                            "stroke-width": "1",
                            fill: "none",
                            "fill-rule": "evenodd",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "cart",
                                transform: "translate(-512.000000, -28.000000)",
                                stroke: "#93999C",
                                "stroke-width": "1.4",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "icon/closeGrey",
                                    transform:
                                      "translate(513.000000, 29.000000)",
                                  },
                                },
                                [
                                  _c("line", {
                                    attrs: {
                                      x1: "14",
                                      y1: "0",
                                      x2: "0",
                                      y2: "14",
                                      id: "Stroke-429",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("line", {
                                    attrs: {
                                      x1: "14",
                                      y1: "14",
                                      x2: "0",
                                      y2: "0",
                                      id: "Stroke-430",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.is_open,
                      expression: "is_open",
                    },
                  ],
                  staticClass: "text-center w-100",
                },
                [
                  _c(
                    "h3",
                    {
                      staticClass:
                        "popup__title font__family--gotham font__weight--medium font__color--gray",
                    },
                    [_vm._t("title")],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-left" }, [
                    _c(
                      "div",
                      { staticClass: "popup__desc popup__desc--min-height" },
                      _vm._l(_vm.payment_methods, function (item, key, index) {
                        return _c(
                          "div",
                          {
                            key: key,
                            staticClass: "py-2 py-lg-4",
                            class: {
                              "border__top border__color--gray": index !== 0,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between mb-2",
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "heading__h5 font__family--gotham font__weight--medium font__color--gray m-0",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(item.title)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "m-0" }, [
                                  item.icon
                                    ? _c("img", {
                                        attrs: {
                                          src: item.icon,
                                          alt: "payment ico",
                                        },
                                      })
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "heading__desc font__family--gotham font__weight--light font__color--gray m-0 text-left",
                              domProps: { innerHTML: _vm._s(item.description) },
                            }),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "button button__size-1 button__font--size-1 text-white button__new button__new--blue",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.closePopup.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "font__family--gotham font__weight--medium font__color--white",
                        },
                        [_vm._t("btn_text")],
                        2
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }